import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import FireImage from '../images/fire-alt-solid.svg';
import PlanList from '../PlanList';
import { Plans } from '../../constants';
import styles from './plan-card.module.scss';

const PlanCard = ({ planReference, selectedPlan, handlePlanChange }) => {
  const isAnual = planReference === Plans.ANNUAL;
  return (
    <div
      className={
        cx({ [styles.active]: planReference === selectedPlan })
      }
    >
      <div
        className={styles['plan-card']}
        onClick={handlePlanChange}
        onKeyPress={handlePlanChange}
        role="button"
        tabIndex={isAnual ? '1' : '0'}
      >
        {planReference === selectedPlan
          && (<div className={styles['plan-card__selected-badge']}>Selected Plan</div>)}
        <div className={styles['plan-card__title']}>
          <h3>
            {isAnual ? 'Annual' : 'Seasonal'}
          </h3>
          {isAnual && (
            <div className={styles['plan-card__badge']}>
              <img src={FireImage} className={styles['plan-card__badge-icon']} />
              Best Value
            </div>
          )}
        </div>
        <span className={cx(styles['plan-card__description'], { [styles.highlight]: isAnual })}>
          {isAnual ? 'Prepay for 4 boxes and save $20' : 'Pay per box'}
        </span>
        <div className={styles['plan-card__pricing']}>
          <span>{isAnual ? '$179.99 ' : '$49.99 '}</span>
          <span>USD</span>
        </div>
        <div className={styles['plan-card__info']}>
          {isAnual ? 'Billed yearly. $45 per box, compared to Seasonal.' : 'Billed quarterly.'}
        </div>
        <div className={styles['plan-card__divider']} />
        <div className={styles['plan-card__list']}>
          <PlanList selectedPlan={planReference} />
        </div>
      </div>
    </div>
  );
};

PlanCard.defaultProps = {
  planReference: '',
  selectedPlan: Plans.ANNUAL,
  handlePlanChange: () => {},
};

PlanCard.propTypes = {
  planReference: PropTypes.string,
  selectedPlan: PropTypes.string,
  handlePlanChange: PropTypes.func,
};

export default PlanCard;
